import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';

// Components
import BackButton from '../../atoms/BackButton/BackButton';

import styles from './AuthTemplate.module.scss';

function AuthTemplate({ title, children, showBackButton }) {
  const { t } = useTranslation();

  return (
    <div className={styles.window}>
      <div className={styles.window_inner}>
        {showBackButton ? (
          <a href="/login" className="no-hover">
            <BackButton theme="light" buttonLabel={t('login.back')} />
          </a>
        ) : null}

        {title ? (
          <h1 className="fs-40 fw-500 c-neutral-01 m-b-25">{title}</h1>
        ) : null}

        {children}
      </div>
    </div>
  );
}

AuthTemplate.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  showBackButton: PropTypes.bool,
};

AuthTemplate.defaultProps = {
  title: null,
  children: null,
  showBackButton: false,
};

export default AuthTemplate;
